module.exports = __webpack_public_path__ + "static/media/fetal-pillow-brochure.1088f49b.png";